<template>
  <v-row class="mt-1">
    <v-col>
      <ValidationObserver ref="lotForm" v-slot="{ invalid, validated }">
        <v-expansion-panels multiple>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="info" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="info">
                  <v-icon>
                    info
                  </v-icon>
                  {{ $t("Общая информация") }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col cols="12" class="pl-2 pt-0">
                    <validatable-text-input
                        v-model="lotTemplate.lotDescription"
                        :readonly="readonly"
                        rules="required"
                        :label="$t('Предмет договора')" />
                  </v-col>
                  <v-col cols="12" class="pl-2">
                    <validatable-enum-combobox
                        v-model="lotTemplate.premiumType"
                        :values-enum="PREMIUM_TYPE_ENUM"
                        rules="required"
                        dense
                        :readonly="readonly"
                        :clearable="!readonly"
                        :label="$t('Способ расчета цены')" />
                  </v-col>
                  <v-col cols="12" class="pl-2">
                    <validatable-text-input
                        v-if="isFixPremium"
                        v-model="lotTemplate.currency"
                        rules="required"
                        readonly
                        :label="$t('Валюта Договора')" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="contacts" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="contact_mail">
                  <v-icon>
                    contact_mail
                  </v-icon>
                  {{ $t("Контактная информация") }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col cols="12" md="6" class="pl-2">
                    <validatable-text-input
                        v-model="lotTemplate.contactPerson"
                        v-test="{ input: 'contactPerson' }"
                        prepend-icon="person"
                        rules="required"
                        dense
                        :label="$t('Контактное лицо')" />
                  </v-col>
                  <v-col cols="12" md="6" class="pl-2">
                    <validatable-text-input
                        v-model="lotTemplate.contactPhone"
                        v-test="{ input: 'contactPhone' }"
                        dense
                        :rules="{ required: true, regex: /^[+]?[\d\s(\-);,]+$/ }"
                        :label="$t('Контактный телефон')"
                        prepend-icon="settings_phone"
                        :type="'tel'" />
                  </v-col>
                  <v-col cols="12" md="6" class="pl-2">
                    <validatable-text-input
                        v-model="lotTemplate.contactEmail"
                        v-test="{ input: 'contactEmail' }"
                        dense
                        rules="required|email"
                        :label="$t('Электронный адрес')"
                        prepend-icon="alternate_email" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="contacts" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="contact_mail">
                  <v-icon>
                    contact_mail
                  </v-icon>
                  {{ $t("Клиент") }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col cols="12" md="6" class="pl-2">
                    <validatable-text-input
                        v-model="lotTemplate.clientOrganizationInn"
                        v-test="{ input: 'clientOrganizationInn' }"
                        dense
                        :label="$t('ИНН организации Клиента')" />
                  </v-col>
                  <v-col cols="12" md="6" class="pl-2">
                    <validatable-text-input
                        v-model="lotTemplate.clientOrganizationFullName"
                        v-test="{ input: 'clientOrganizationFullName' }"
                        dense
                        :label="$t('Полное наименование организации Клиента')" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-alert class="text-center" :value="invalid && validated" type="error">
          {{ $t("Не все поля заполнены.") }}
        </v-alert>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
  import Vue from 'vue'
  // import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import { DICTIONARY_TYPES, PREMIUM_TYPES } from '@/constants/business'
  import { PREMIUM_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      // ValidatableDatePicker,
      ValidatableTextInput,
      ValidatableEnumCombobox
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      saveMethod: {
        type: Function
      },
      lotTemplateInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        DICTIONARY_TYPES,
        PREMIUM_TYPE_ENUM,
        lotTemplate: {
          creatorId: null,
          lotDescription: null,
          publicationDate: null,
          premiumType: null,
          currency: null,
          contactPerson: null,
          contactPhone: null,
          contactEmail: null,
          clientOrganizationFullName: null,
          clientOrganizationInn: null
        }
      }
    },
    computed: {
      hasChanges () {
        return Object.keys(this.lotTemplate).some(key => {
          return this.lotTemplate[key] !== this.lotTemplateInfo[key]
        })
      },
      isFixPremium () {
        return this.lotTemplate.premiumType === PREMIUM_TYPES.FIX
      }
    },
    watch: {
      lotTemplateInfo: {
        deep: true,
        immediate: true,
        handler: function (newVal) {
          this.mapFields(newVal)
        }
      }
    },
    beforeDestroy () {},
    created () {},
    methods: {
      validateAndSave: async function () {
        const result = await this.$refs.lotForm.validate()
        if (!result) {
          throw new Vue.errorsTypes.ValidationError()
        }
        // если изменений нет, то сохранение не нужно
        if (this.readonly || !this.hasChanges) {
          return
        }
        if (this.saveMethod) {
          await this.saveMethod(this.lotTemplate)
        }
      },
      mapFields: async function (lotTemplate) {
        if (!lotTemplate.lotTemplateId) {
          return
        }
        for (const key in this.lotTemplate) {
          if (this.lotTemplate[key] !== lotTemplate[key]) {
            this.lotTemplate[key] = lotTemplate[key]
          }
        }
      }
    }
  }
</script>
